import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContestState, CONTEST_TAG } from './contest.state';

const ContestSelector = createFeatureSelector<ContestState>(CONTEST_TAG);

export const getRequests = createSelector(ContestSelector, (state: ContestState) => state?.requests);
export const getErrorRequests = createSelector(ContestSelector, (state: ContestState) => state?.errorRequests);
